import { type SVGProps } from '@fortuneo/ui-icons/general/types'
import clsx from 'clsx/lite'
import React from 'react'

export type ClickableIconProps = {
  icon?: (props: SVGProps) => JSX.Element
  onClick?: React.MouseEventHandler<HTMLButtonElement>
  size?: number
} & React.ButtonHTMLAttributes<HTMLButtonElement>

export const ClickableIcon: React.FC<ClickableIconProps> = ({
  icon: Icon,
  size = 36,
  ...props
}) => (
  <button
    type="button"
    className={clsx(
      'items center flex appearance-none justify-center rounded bg-transparent p-0',
      'focus-within:outline focus-within:outline-3 focus-within:outline-offset-4 focus-within:outline-border-focus'
    )}
    {...props}
  >
    <Icon size={size} />
  </button>
)
